import api from "@/services";
import utils from "@/services/utils";

const state = {
  emailProperties: {
    textHeadEmail: "",
    textBodyEmail: "",
    textProposalEmail: "",
    textBudgetEmail: "",
    senderEmail: "user@email.com",
    textSubjectEmail: "Assunto do Email"
  }
};

const mutations = {
  FETCH_EMAIL_CONTENT(state, data) {
    state.emailProperties.textHeadEmail = data.salutation;
    state.emailProperties.textBodyEmail = data.body;
    state.emailProperties.textProposalEmail = data.proposalTitle;
    state.emailProperties.textBudgetEmail = data.proposalInformation;
    state.emailProperties.textSubjectEmail = data.subject
      ? data.subject
      : state.emailProperties.textSubjectEmail;
  }
};

const actions = {
  async fetchContentEmail({ commit }, query) {
    const response = await utils.request(api.email.getContentEmail(query));
    if (response && response.status === 200) {
      const { data } = response;
      const emailContent = data.find(a => a.typeofContent === "email");
      commit("FETCH_EMAIL_CONTENT", emailContent);
    }
    return response;
  },
  async patchContentEmail({ commit }, data) {
    const response = await utils.request(api.email.updateContentEmail(data));
    if (response && response.status === 200) {
      return response;
    }
    console.error(response);
    return null;
  },
  async postTestContentEmail({ commit }, data) {
    const response = await utils.request(api.email.postEmailTest(data));
    if (response && response.status === 200) {
      return response;
    }
    console.error(response);
    return response;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/editTemplateEmail.js